// Lightweight, local sentiment read on a coach's reply — no extra LLM call, no added latency.
// Drives the avatar's emotional presentation (see CompanionAvatar) so the coach visibly reacts
// to what's being discussed instead of wearing one fixed expression the whole conversation.
export type Mood = 'neutral' | 'concerned' | 'celebratory'

const CONCERNED = [
  'worried', 'worrying', 'concern', 'concerning', 'concerned', "i'm a little concerned",
  'keep an eye', "let's watch", 'watch this', 'not great', 'not ideal', 'sorry to hear',
  'that sounds hard', 'that sounds tough', 'i hear you', 'crept up', 'trending up', 'trending down',
  'dropped', 'falling', 'declined', 'elevated', 'high risk', 'red flag', 'concerning trend',
  'watch closely', 'please see', 'call your doctor', 'seek care', 'urgent', 'emergency',
]
const CELEBRATORY = [
  'great job', 'nice work', 'amazing', 'proud of you', "you're crushing", 'crushing it',
  'well done', 'fantastic', 'love that', 'love this', "that's huge", "that's great",
  'keep it up', 'way to go', '🎉', '🔥', '💪', 'milestone', 'streak', 'unlocked', 'congrat',
  "you did it", 'awesome',
]

export function classifyMood(text: string): Mood {
  const low = text.toLowerCase()
  const hits = (words: string[]) => words.reduce((n, w) => n + (low.includes(w) ? 1 : 0), 0)
  const concerned = hits(CONCERNED)
  const celebratory = hits(CELEBRATORY)
  if (concerned === 0 && celebratory === 0) return 'neutral'
  return celebratory > concerned ? 'celebratory' : 'concerned'
}
